import { Component, Input } from "@angular/core";
import { IdService } from "../shared/services/id.service";


@Component({
	selector: "rbc-status",
	template: `
		<span
			*ngIf="text"
			[id]="id"
			class="rbc-status"
			aria-live="assertive"
			[ngClass]="classGen()"
			[attr.aria-controls]= "ariaControls ? ariaControls : id"
		>
			<rbc-icon
				[icon]= "iconGen"
				class="rbc-status-icon"
				[attr.aria-hidden]="true"
				type="solid"
			></rbc-icon>
			{{ text }}
		</span>
	`,
	styles: []
})
export class StatusComponent {
	@Input() srOnly: boolean;
	@Input() text: string;
	@Input() id: string;
	@Input() type: "success" | "warning" | "danger" | "info" = "info";
	@Input() ariaControls: string;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	classGen() {
		let newClass = {};
		newClass["sr-only"] = this.srOnly;
		newClass["rbc-status-" + this.typeCheck] = true;

		return newClass;
	}

	get typeCheck() {
		return this.type === "success" ||
			this.type === "warning" ||
			this.type === "danger" ||
			this.type === "info"
			? this.type
			: "info";
	}

	get iconGen() {
		const icons = {
			danger: "exclamation-square",
			success: "check-circle",
			warning: "exclamation-triangle",
			info: "info-circle"
		};

		// return this.icon || icons[this.type];
		return icons[this.type];
	}
}
